package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue

import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.densities.DensitiesScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_strikeradar_densities
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem

import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters

import kotlinx.serialization.Serializable

@Serializable
object RouteLightningDensitiesAdmin : RouteParameterTo

object RouterLightningDensitiesAdmin :
    RouterNoParameters<RouteLightningDensitiesAdmin>(RouteLightningDensitiesAdmin::class) {
    override fun routeFrom(parameters: RouteLightningDensitiesAdmin) = "/densities/admin"

    @Composable
    override fun Show(parameters: RouteLightningDensitiesAdmin) {
        RouteLightningDensitiesAdminImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteLightningDensitiesAdmin,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteLightningDensitiesAdmin

    override fun isMatching(route: String) = route == "/densities/admin"

    override fun navigateFrom(path: String) = RouteLightningDensitiesAdmin
}

class RouteLightningDensitiesAdminImpl : Route<RouteLightningDensitiesAdmin>(
    route = "/densities/admin",
    params = RouteLightningDensitiesAdmin,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        DensitiesScreen(
            currentInterface = state.apiProvider!!.apiAdmin!!,
            onNavigateLightningCertificates = {
                appModel.show(RouterLightningCertificatesAdmin.navigateTo())
            }
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_strikeradar_densities,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        appModel.logout()
                    }
                )
            )
        )
    }
}
